"use strict";
exports["-3c9e636"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizEasTitleText","properties":{"useAutodiscover":{"type":"boolean","title":"LabelAutodiscoverGroup","default":true,"enum":[true,false],"enumNames":["LabelUseAutodiscoverRadio","LabelManuallySpecifyServerSettings"]},"authenticationType":{"type":"string","title":"LabelAuthenticationType","default":"Basic","enum":["OAuth","Basic"],"enumNames":["AuthenticationTypeOAuth","AuthenticationTypeBasic"]},"syncInbox":{"type":"boolean","title":"LabelSyncInbox"},"ignoreTrustForSsl":{"type":"boolean","title":"LabelIgnoreTrustForSsl","default":false},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["useAutodiscover","authenticationType","notice","proofOfWork"],"dependencies":{"useAutodiscover":{"oneOf":[{"properties":{"useAutodiscover":{"enum":[true]},"emailAddress":{"type":"string","title":"LabelEmailAddress","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"}},"required":["emailAddress"]},{"properties":{"useAutodiscover":{"enum":[false]},"easServer":{"type":"string","title":"LabelEasServer","pattern":"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"}},"required":["easServer"]}]},"authenticationType":{"oneOf":[{"properties":{"authenticationType":{"enum":["OAuth"]},"oAuthCredential":{"type":"object","title":"OAuthCredentialsLabel"}},"required":["oAuthCredential"]},{"properties":{"authenticationType":{"enum":["Basic"]},"basicAuthNotice":{"type":"object","title":"","properties":{},"required":[]},"userName":{"type":"string","title":"LabelDomainUser","pattern":"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"password":{"type":"string","title":"LabelPassword"}},"required":["basicAuthNotice","userName","password"]}]}},"$id":"-3c9e636"};
const pattern0 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");
const pattern1 = new RegExp("^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$", "u");
const pattern2 = new RegExp("^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3c9e636" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "useAutodiscover"},message:"must have required property '"+"useAutodiscover"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.authenticationType === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "authenticationType"},message:"must have required property '"+"authenticationType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.notice === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.proofOfWork === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.useAutodiscover !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.emailAddress === undefined){
const err4 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/0/required",keyword:"required",params:{missingProperty: "emailAddress"},message:"must have required property '"+"emailAddress"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[0].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === true)){
const err5 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.emailAddress !== undefined){
let data1 = data.emailAddress;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err6 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/emailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress,data:data1};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/emailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress,data:data1};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.easServer === undefined){
const err8 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/1/required",keyword:"required",params:{missingProperty: "easServer"},message:"must have required property '"+"easServer"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[1].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1],data};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.useAutodiscover !== undefined){
let data2 = data.useAutodiscover;
if(!(data2 === false)){
const err9 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.easServer !== undefined){
let data3 = data.easServer;
if(typeof data3 === "string"){
if(!pattern1.test(data3)){
const err10 = {instancePath:instancePath+"/easServer",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/easServer/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},message:"must match pattern \""+"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"+"\"",schema:"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.easServer,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/easServer",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/easServer/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.easServer.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.easServer,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err12 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.useAutodiscover.oneOf,parentSchema:schema11.dependencies.useAutodiscover,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.authenticationType !== undefined){
const _errs12 = errors;
let valid4 = false;
let passing1 = null;
const _errs13 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err13 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/0/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.dependencies.authenticationType.oneOf[0].required,parentSchema:schema11.dependencies.authenticationType.oneOf[0],data};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.authenticationType !== undefined){
let data4 = data.authenticationType;
if(!(data4 === "OAuth")){
const err14 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType,data:data4};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.oAuthCredential !== undefined){
let data5 = data.oAuthCredential;
if(!(data5 && typeof data5 == "object" && !Array.isArray(data5))){
const err15 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.dependencies.authenticationType.oneOf[0].properties.oAuthCredential.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.oAuthCredential,data:data5};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
var _valid1 = _errs13 === errors;
if(_valid1){
valid4 = true;
passing1 = 0;
}
const _errs17 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.basicAuthNotice === undefined){
const err16 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "basicAuthNotice"},message:"must have required property '"+"basicAuthNotice"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data.userName === undefined){
const err17 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.password === undefined){
const err18 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.authenticationType !== undefined){
let data6 = data.authenticationType;
if(!(data6 === "Basic")){
const err19 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType,data:data6};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.basicAuthNotice !== undefined){
let data7 = data.basicAuthNotice;
if(!(data7 && typeof data7 == "object" && !Array.isArray(data7))){
const err20 = {instancePath:instancePath+"/basicAuthNotice",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/basicAuthNotice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.dependencies.authenticationType.oneOf[1].properties.basicAuthNotice.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.basicAuthNotice,data:data7};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.userName !== undefined){
let data8 = data.userName;
if(typeof data8 === "string"){
if(!pattern2.test(data8)){
const err21 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/pattern",keyword:"pattern",params:{pattern: "^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data8};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.userName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data8};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.password !== undefined){
let data9 = data.password;
if(typeof data9 !== "string"){
const err23 = {instancePath:instancePath+"/password",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.password.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.password,data:data9};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
var _valid1 = _errs17 === errors;
if(_valid1 && valid4){
valid4 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid4 = true;
passing1 = 1;
}
}
if(!valid4){
const err24 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.authenticationType.oneOf,parentSchema:schema11.dependencies.authenticationType,data};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
else {
errors = _errs12;
if(vErrors !== null){
if(_errs12){
vErrors.length = _errs12;
}
else {
vErrors = null;
}
}
}
}
if(data.useAutodiscover !== undefined){
let data10 = data.useAutodiscover;
if(typeof data10 !== "boolean"){
const err25 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.useAutodiscover.type,parentSchema:schema11.properties.useAutodiscover,data:data10};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(!((data10 === true) || (data10 === false))){
const err26 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.useAutodiscover.enum,parentSchema:schema11.properties.useAutodiscover,data:data10};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.authenticationType !== undefined){
let data11 = data.authenticationType;
if(typeof data11 !== "string"){
const err27 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.authenticationType.type,parentSchema:schema11.properties.authenticationType,data:data11};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(!((data11 === "OAuth") || (data11 === "Basic"))){
const err28 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.authenticationType.enum,parentSchema:schema11.properties.authenticationType,data:data11};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.syncInbox !== undefined){
let data12 = data.syncInbox;
if(typeof data12 !== "boolean"){
const err29 = {instancePath:instancePath+"/syncInbox",schemaPath:"#/properties/syncInbox/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.syncInbox.type,parentSchema:schema11.properties.syncInbox,data:data12};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.ignoreTrustForSsl !== undefined){
let data13 = data.ignoreTrustForSsl;
if(typeof data13 !== "boolean"){
const err30 = {instancePath:instancePath+"/ignoreTrustForSsl",schemaPath:"#/properties/ignoreTrustForSsl/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.ignoreTrustForSsl.type,parentSchema:schema11.properties.ignoreTrustForSsl,data:data13};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.notice !== undefined){
let data14 = data.notice;
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.testAccountConsent === undefined){
const err31 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data14};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data14.testAccountConsent !== undefined){
let data15 = data14.testAccountConsent;
if(typeof data15 !== "boolean"){
const err32 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data15};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data14};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data16 = data.proofOfWork;
if(typeof data16 !== "string"){
const err34 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data16};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-7ab24ebe"] = validate11;
const schema12 = {"type":"object","properties":{"useAutodiscover":{"enum":[true]}},"$id":"-7ab24ebe"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-7ab24ebe" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema12.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.useAutodiscover.enum,parentSchema:schema12.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["-16cb1543"] = validate12;
const schema13 = {"type":"object","properties":{"useAutodiscover":{"enum":[false]}},"$id":"-16cb1543"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-16cb1543" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema13.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.useAutodiscover.enum,parentSchema:schema13.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}

exports["249b33cc"] = validate13;
const schema14 = {"type":"object","properties":{"authenticationType":{"enum":["OAuth"]}},"$id":"249b33cc"};

function validate13(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="249b33cc" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "OAuth")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema14.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema14.properties.authenticationType.enum,parentSchema:schema14.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema14.type,parentSchema:schema14,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate13.errors = vErrors;
return errors === 0;
}

exports["-3625bd4b"] = validate14;
const schema15 = {"type":"object","properties":{"authenticationType":{"enum":["Basic"]}},"$id":"-3625bd4b"};

function validate14(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3625bd4b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "Basic")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema15.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema15.properties.authenticationType.enum,parentSchema:schema15.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema15.type,parentSchema:schema15,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate14.errors = vErrors;
return errors === 0;
}
